export default __webpack_public_path__ + "static/media/hodlftmZLP.d383dff2.png";